import request, { appendApiUrl } from '@/utils/request'
import { deleteEmpty } from './common.js'
import { trackSuccessfulPurchase } from '@/pages/firebase'
import { regionCodeMap } from '@/consts/index'

export function getUserOrderHistory(options) {
  return request.postJson({
    url: appendApiUrl('/order/query/list'),
    data: deleteEmpty(options),
  })
}

// 查询用户单个订单信息
export function getOrderDetail(options = {}) {
  return request.postJson({
    url: appendApiUrl('/order/query/detail'),
    data: deleteEmpty(options),
  })
}

// 用户发奖查询系统(当前仅code)
export function getOrderAward(options) {
  return request.postJson({
    url: appendApiUrl('/order/query/award'),
    data: deleteEmpty(options),
  })
}

export function getUserTotalSaving(options) {
  return request.postJson({
    url: appendApiUrl('/order/query/totalSaving'),
    data: deleteEmpty(options),
  })
}

// 用户订单列表查询
export function getOrderDetailList(options) {
  return request.postJson({
    url: appendApiUrl('/order/query/orderList'),
    data: { ...deleteEmpty(options) },
  })
}

/* 查询订单状态 */
export const queryOrder = (options) => {
  return request.postJson(
    {
      url: appendApiUrl('/order/query/detail/no-login'),
      data: { ...options },
    },
    {
      showLoading: false,
    }
  )
}

// 用户通过订单号领券 「ABtest」
export const couponAfterPay = (options) => {
  return request.postJson(
    {
      url: appendApiUrl('/activity/save/coupon/after/pay'),
      data: { ...options },
    },
    {
      showLoading: false,
    }
  )
}

export async function queryOrderStatus(orderNum, region) {
  const orderInfo = await queryOrder({
    orderNo: orderNum,
  })
  const countryCode = regionCodeMap[region]
  const {
    orderStatus,
    couponId,
    currency,
    game = '',
    orderNo,
    originPrice,
    payPrice,
    skuId,
    skuName,
  } = orderInfo
  const id = `${countryCode}${skuId}`
  const brand = `${game.toLowerCase()}_${region}`
  if (orderStatus * 1 === 10) {
    // 当前只有新订单
    trackSuccessfulPurchase({
      transaction_id: orderNo,
      coupon: couponId,
      currency,
      value: payPrice, // 实际支付价格
      items: [
        {
          id,
          name: skuName,
          brand,
          quantity: 1, // 当前写死为1
          price: originPrice,
        },
      ],
    })
    return orderInfo || {}
  }
}

export function queryPayResult(options) {
  return request.postJson({
    url: appendApiUrl('/banner/pay_result/query'),
    data: { ...options },
  })
  // return new Promise((resolve) => {
  //   resolve({
  //     awardType: 0,
  //     bannerConfigs: [
  //       {
  //         // activityId: 684,
  //         activityId: null,
  //         country: '',
  //         createTime: 0,
  //         customizeSource: '',
  //         desc: '',
  //         endTime: 0,
  //         game: '',
  //         id: 0,
  //         jumpType: 2,
  //         login: 0,
  //         mainTitle: '',
  //         order: 0,
  //         picture: require(`@/assets/images/pay/banner.png`),
  //         sourceType: 0,
  //         startTime: 0,
  //         status: 0,
  //         subTitle: 'DESCONTO DE ATÉ R$ 68,00 O DE ATÉ...',
  //         title: 'PUBG Mobile',
  //         type: 0,
  //         updateTime: 0,
  //         url: 'https://www-staging.toplupe.com/pubgm',
  //         userType: 0,
  //       },
  //     ],
  //     couponNum: 1,
  //     decreaseMoney: 0,
  //     game: 'pubgm',
  //     skuId: '',
  //     skuName: '',
  //   })
  // })
}
